import script from "./RequestUpdateModalForBarcode.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUpdateModalForBarcode.vue?vue&type=script&setup=true&lang=js"

import "./RequestUpdateModalForBarcode.vue?vue&type=style&index=0&id=1681ba98&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1681ba98"]])

export default __exports__